export const brokenEmbedPreviewTestIds = {
  root: 'broken-embed-preview',
};
